/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Last_ModifiedInputs */

const en_common_last_modified = /** @type {(inputs: Common_Last_ModifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last modified`)
};

const es_common_last_modified = /** @type {(inputs: Common_Last_ModifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Última modificación`)
};

/**
* | output |
* | --- |
* | "Last modified" |
*
* @param {Common_Last_ModifiedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_last_modified = /** @type {((inputs?: Common_Last_ModifiedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Last_ModifiedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_last_modified(inputs)
	return en_common_last_modified(inputs)
});